import React from 'react';
import {Button, Media} from 'reactstrap';
import ReactTooltip from "react-tooltip";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import {MdCreate, MdDelete} from 'react-icons/md';

let commonStrings = new LocalizedStrings(common_strings);

const RuleTableRow = (props) => {

    function teacherName() {
        return props.rule.teachers && props.rule.teachers.length > 0 ? props.rule.teachers[0].name : ""
    }

    function days() {
        function dayName(dayNumber) {
            switch (dayNumber) {
                case "0":
                    return commonStrings.short_day.mon;
                case "1":
                    return commonStrings.short_day.tue;
                case "2":
                    return commonStrings.short_day.wed;
                case "3":
                    return commonStrings.short_day.thu;
                case "4":
                    return commonStrings.short_day.fri;
                case "5":
                    return commonStrings.short_day.sat;
                case "6":
                    return commonStrings.short_day.sun;
                default:
                    return ""
            }
        }

        const d = props.rule.days.split(",");
        const dd = d.map(it => dayName(it));
        return dd.join(", ")
    }

    function weeks() {
        switch (props.rule.regularity) {
            case "1,2,3,4" || "0,1,2,3,4,5,6":
                return commonStrings.every_week;
            case "2,4" || "0,2,4,6":
                return commonStrings.even_weeks;
            case "1,3" || "1,3,5":
                return commonStrings.odd_weeks;
            default:
                return ""
        }
    }

    return (
        <tr>
            <th scope="row">
                <Media className="align-items-center">
                    <div>
                        {props.rule && props.rule.time ? props.rule.time : ""}
                    </div>
                </Media>
                <div className="align-items-left ml-1">
                    <small>
                        <div>
                            {days()} <b>{weeks()}</b>
                        </div>
                    </small>
                </div>
            </th>
            <td>
                {teacherName()}
            </td>
            <td>

            </td>
            <ReactTooltip/>
            <td className="text-right align-content-end">
                <div>
                    <Button
                        className="btn-icon ct-example-tooltip-static"
                        color="warning"
                        data-type="error"
                        data-tip={commonStrings.delete}
                        onClick={e => props.deleteRule(e, props.rule)}>
                        <MdDelete/>
                    </Button>
                    <Button
                        color="secondary"
                        data-type="info"
                        data-tip={commonStrings.edit}
                        onClick={e => props.editRule(e, props.rule)}>
                        <MdCreate/>
                    </Button>

                </div>
            </td>
        </tr>
    )
};

export default RuleTableRow;